import React from 'react';
import PropTypes from 'prop-types';

/**
 * Mockup-style section divider (mono label + rule). Used on Hunts list and Hunt log form.
 */
export function HuntSectionHeader({ label, title, className = '' }) {
  return (
    <header className={`hunts-shell__form-section-intro ${className}`.trim()}>
      {label ? (
        <div className="hunts-shell__section-row">
          <span className="hunts-shell__section-label">{label}</span>
          <span className="hunts-shell__section-rule" aria-hidden="true" />
        </div>
      ) : null}
      {title ? <h2 className="hunts-shell__form-section-title">{title}</h2> : null}
    </header>
  );
}

HuntSectionHeader.propTypes = {
  label: PropTypes.string,
  title: PropTypes.string,
  className: PropTypes.string,
};
